import React, { useContext, useEffect, useState } from "react";
import NotificationBar from "./NotificationBar";
import NotificationContent from "./Notifications";
import axios from "../../axios/axios";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../components/PageLoader";
import {
  setAdminNotificationCount,
  setNotificationFilter,
} from "../../redux/slice/adminNotificationSlice";
import { useNavigate } from "react-router-dom";
import { NotificationContext } from "../DashboardLayout";
import { AuthenticationContext } from "../../App";
import LoaderImage from "../../images/ohhto-loading.gif";
import useViewportWidth from "../../utils/useViewportWidth";
import { CommomPermission } from "../../common/Constants";

const AddPropertyToArray = (data) => {
  return data.map((item) => ({
    ...item,
    label: item?.name,
    key: item?.id,
  }));
};

const NotificationLayout = () => {
  const viewportWidth = useViewportWidth();
  const [notfBar, setNotfBar] = useState(false);
  const { authData, } = useContext(
    AuthenticationContext
  );
  const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "loan")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "loan-application-cases");
  const FloorPagePErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;

  useEffect(() => {
    setNotfBar(viewportWidth <= 1180);
  }, [viewportWidth]);

  const accessToken = localStorage.getItem("dealerModuleToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filters = useSelector(
    (state) => state?.adminNotificationFilter?.notificationFilter
  );
  const { setNotificationCount } = useContext(AuthenticationContext);
  const settings = useSelector((state) => state.settings);
  const [loading, setLoading] = useState(false);
  const [adminNotifications, setAdminNotifications] = useState([]);
  const [totalAdminNotifications, setTotalAdminNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [notificationTabs, setNotificationsTab] = useState([]);

  const [applyFilters, setApplyFilters] = useState(
    Object.keys(filters)?.length > 0
      ? filters
      : {
        productType: "",
        sortBy: "month",
      }
  );
  const [activeTab, setActiveTab] = useState({});

  const OnNotifcationRead = async (type, groupby) => {
    let res = await axios.put(
      `/notification/status/update/${groupby}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  };

  const setInitialNotification = (adminNotification) => {
    if (adminNotification?.length > 0) {
      const temp = adminNotification?.filter(
        (it) => it?.notification_type !== "application"
      );
      if (adminNotification[0]?.notification_type === "application") {
        let unReadNotification = adminNotification?.filter(
          (it) => it?.status === 0
        )?.length;
        setNotificationCount(unReadNotification);
        dispatch(setAdminNotificationCount(unReadNotification));
      } else {
        let unReadNotification = adminNotification
          ?.filter((id, index) => index !== 0)
          ?.filter((it) => it?.status === 0)?.length;
        setNotificationCount(unReadNotification);
        dispatch(setAdminNotificationCount(unReadNotification));
      }

      if (temp?.length > 0) {
        setSelectedNotification(temp[0]);
        const newState = adminNotification.map((obj) => {
          if (obj.index === temp[0]?.index) {
            return { ...obj, status: 1 };
          }
          return obj;
        });
        setAdminNotifications(newState);
        OnNotifcationRead("intial", temp[0]?.groupby);
      }
    } else {
      setNotificationCount(0);
      setSelectedNotification({});
      dispatch(setAdminNotificationCount(0));
    }
  };

  const GetAdminNotifications = async () => {
    setLoading(true);
    const { data } = await axios.post(`/notification/list`, applyFilters, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    setAdminNotifications(data?.data);
    setInitialNotification(data?.data);
    setTotalAdminNotifications(data?.data);
    setLoading(false);
  };

  const onSearch = (key) => {
    let temp = totalAdminNotifications.filter((item) => {
      return item?.name?.toLowerCase()?.includes(key?.toLowerCase());
    });

    if (temp !== undefined && temp !== null) {
      setAdminNotifications(temp);
    }
  };

  const OnNotificationSelecct = (id) => {

    let temp = adminNotifications?.filter((it) => it?.index === id);

    const newState = adminNotifications.map((obj) => {
      if (obj.index === id) {
        return { ...obj, status: 1 };
      }
      return obj;
    });
    setAdminNotifications(newState);
    setNotificationCount(newState?.filter((it) => it?.status === 0)?.length);
    if (temp?.length > 0 && temp[0]?.notification_type !== "application") {
      setSelectedNotification(temp[0]);
      temp[0]?.status !== 1 && OnNotifcationRead("click", temp[0]?.groupby);
    } else {
      temp[0]?.status !== 1 && OnNotifcationRead("click", temp[0]?.groupby);
      setTimeout(() => {
        navigate("/case-detail", { state: { Id: temp[0]?.id, pagePermission: FloorPagePErmission } });
      }, 500);
    }
  };

  const onFilterChange = (type, value) => {
    setApplyFilters({
      ...applyFilters,
      [type]: value,
    });
    dispatch(
      setNotificationFilter({
        ...applyFilters,
        [type]: value,
      })
    );
  };

  useEffect(() => {
    if (settings?.loanProviderTypes?.length > 0) {
      setNotificationsTab(AddPropertyToArray(settings?.loanProviderTypes));
    }
  }, [settings]);

  useEffect(() => { }, [adminNotifications]);

  useEffect(() => {
    GetAdminNotifications();
  }, [applyFilters]);

  return (
    <div className="flex w-full">
      {loading && (
        <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
          <img src={LoaderImage} className="w-24 h-24" />
        </div>
      )}
      <NotificationBar
        adminNotifications={adminNotifications}
        OnNotificationSelecct={OnNotificationSelecct}
        notificationTabs={notificationTabs}
        onFilterChange={onFilterChange}
        onSearch={onSearch}
        loading={loading}
        selectedNotification={selectedNotification}
        applyFilters={applyFilters}
        reload={GetAdminNotifications}
        notfBar={notfBar}
        notfBarClose={() => setNotfBar(false)}
      />
      <NotificationContent
        selectedNotification={selectedNotification}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        notfBar={() => setNotfBar(true)}
      />
    </div>
  );
};

export default NotificationLayout;
